export default __webpack_public_path__ + "static/media/Banco.4d7ca193.png";